<!-- 工作台 -->
<template>
    <div v-loading="loading">
        <div class="permission-ctn">
            <div class="permission-tree">
                <el-tree
                    ref="tree"
                    :check-strictly="true"
                    :data="treeData"
                    :props="defaultProps"
                    :expand-on-click-node="false"
                    show-checkbox
                    node-key="Id"
                    default-expand-all
                    :default-checked-keys="checkedTree"
                    @check="handleNodeChecked"
                >
                    <div class="custom-tree-node" slot-scope="{ node, data }">
                        <span class="element-name" :class="{ lv3: node.level == 3 }">{{ data.Name }}</span>
                        <span class="element-ops">
                            <span v-for="item in data.Elements" :key="item.Id">
                                <input type="checkbox" v-bind:value="item.Id" v-model="selelementsId" @change="checkElem($event, item, node)" />
                                {{ item.Name }}
                            </span>
                        </span>
                    </div>
                </el-tree>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['staffId'],
    name: '',
    data() {
        return {
            unionId: this.$util.getLocalStorage('currentUnion'),
            loading: false,
            treeData: [], //模块树数据集
            checkedTree: [], //已选中的树节点
            selelementsId: [],
            parentsData: [],
            assignPermissions: [],
            defaultProps: {
                children: 'Children',
                label: 'Name'
            }
        };
    },
    mounted() {
        if (this.staffId) {
            this.getSelectedAuth();
        }
    },
    methods: {
        getSelectedAuth() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/Permission/GetCheckedUnionStaffModulesIds',
                    data: {
                        StaffId: this.staffId,
                        UnionId: this.unionId
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.checkedTree = res.data.selmodulesId;
                    this.selelementsId = res.data.selelementsId;

                    if (!this.treeData || this.treeData.length == 0) {
                        this.getPermission();
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 获取模块树接口
        getPermission() {
            this.$util
                .axiosGet({
                    url: '/api/Permission/GetEntpUnionModulesTree',
                    data: {
                        UnionId: this.unionId,
                        IsEdit: true
                    }
                })
                .then(res => {
                    let data = res.data;
                    this.treeData = data;
                });
        },
        // 勾选模块
        handleNodeChecked(data, node) {
            this.assignPermissions = [];
            this.parentsData = [];
            let parentNode = this.$refs.tree.getNode(data.Id);
            if (parentNode) {
                this.getParentsNames(parentNode, []);
            }
            let _checkedTree = this.$refs.tree.getCheckedKeys();
            let flag = false;
            for (let i = 0; i < _checkedTree.length; i++) {
                if (_checkedTree[i] == data.Id) {
                    flag = true;
                    break;
                }
            }
            if (flag) {
                this.checkTreeNoHttp(data, true);
                this.parentsData.forEach(item => {
                    if (this.assignPermissions.findIndex(i => item.key === i.secId) === -1) {
                        this.$refs.tree.setChecked(item.key, true, false);
                        this.assignPermissions.push({
                            key: 'UserUnionModule',
                            secId: item.key
                        });
                    }
                });
                this.AssignPermission();
            } else {
                this.checkTreeNoHttp(data, false);
                this.UnAssignPermission();
            }
        },
        checkTreeNoHttp(node, checked) {
            this.$refs.tree.setChecked(node.Id, checked, 'deep');
            this.assignPermissions.push({ key: 'UserUnionModule', secId: node.Id });
            let that = this;
            //设置菜单下按钮是否选中
            node.Elements.forEach((x, index) => {
                that.assignPermissions.push({ key: 'UserUnionElement', secId: x.Id });
                if (checked && that.selelementsId.indexOf(x.Id) == -1) {
                    that.selelementsId.push(x.Id);
                } else {
                    for (let i = 0; i < that.selelementsId.length; i++) {
                        if (that.selelementsId[i] == x.Id) {
                            that.selelementsId.splice(i, 1);
                            return true;
                        }
                    }
                }
            });
            //循环节点子级
            for (let i = 0; i < node.Children.length; i++) {
                that.$refs.tree.setChecked(node.Children[i].Id, checked, 'deep');
                that.assignPermissions.push({
                    key: 'UserUnionModule',
                    secId: node.Children[i].Id
                });
                //设置菜单下按钮是否选中
                node.Children[i].Elements.forEach((x, index) => {
                    that.assignPermissions.push({ key: 'UserUnionElement', secId: x.Id });
                    if (checked && that.selelementsId.indexOf(x.Id) == -1) {
                        that.selelementsId.push(x.Id);
                    } else {
                        for (let i = 0; i < that.selelementsId.length; i++) {
                            if (that.selelementsId[i] == x.Id) {
                                that.selelementsId.splice(i, 1);
                                return true;
                            }
                        }
                    }
                });
                //递归
                if (node.Children[i].Children[0]) {
                    that.checkTreeNoHttp(node.Children[i], checked);
                }
            }
        },
        //勾选权限操作按钮
        checkElem(event, data, node) {
            this.parentsData = [];
            this.getParentsNames(node, []);
            this.assignPermissions = [];
            this.assignPermissions.push({ key: 'UserUnionElement', secId: data.Id });
            if (event.target.checked) {
                if (this.selelementsId.indexOf(data.Id) == -1) {
                    this.selelementsId.push(data.Id);
                }

                this.parentsData.forEach(item => {
                    if (this.assignPermissions.findIndex(i => item.key === i.secId) === -1) {
                        this.$refs.tree.setChecked(item.key, true, false);
                        this.assignPermissions.push({
                            key: 'UserUnionModule',
                            secId: item.key
                        });
                    }
                });

                this.AssignPermission();
            } else {
                let i = this.selelementsId.findIndex(item => {
                    if (item == data.Id) {
                        return true;
                    }
                });
                if (i > -1) {
                    this.selelementsId.splice(i, 1);
                }
                this.UnAssignPermission();
            }
        },
        // 递归获取未选中父级列表
        getParentsNames(obj, result) {
            if (obj.key) {
                if (!obj.checked) {
                    result.push({
                        key: obj.key,
                        label: obj.label
                    });
                }
                this.getParentsNames(obj.parent, result);
            } else {
                this.parentsData = result;
            }
        },
        //分配权限
        AssignPermission() {
            this.loading = true;
            this.$util
                .axiosPost({
                    url: '/api/Permission/AssignUnionRolePermission',
                    data: {
                        unionId: this.unionId,
                        firstId: this.staffId,
                        permission: this.assignPermissions
                    }
                })
                .then(res => {
                    this.$util.successMsg('分配权限成功');
                    this.assignPermissions = [];
                })
                .catch(() => {
                    this.assignPermissions = [];
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 取消权限分配
        UnAssignPermission() {
            this.loading = true;
            this.$util
                .axiosPost({
                    url: '/api/Permission/UnAssignUnionRolePermission',
                    data: {
                        unionId: this.unionId,
                        firstId: this.staffId,
                        permission: this.assignPermissions
                    }
                })
                .then(res => {
                    this.$util.successMsg('取消权限成功');
                    this.assignPermissions = [];
                })
                .catch(() => {
                    this.assignPermissions = [];
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
<style lang="less" scoped>
.permission-ctn {
    display: flex;
    width: 100%;
    height: 460px;
    overflow: auto;
    padding-bottom: 50px;
}
</style>
<style lang="less">
.element-name {
    display: inline-block;
    width: 150px;
}
.el-tree-node {
    position: relative;
}
</style>
